export default {
  Field: {
    required: 'Required field',
  },
  SearchInput: {
    searchBox: 'Search box',
  },
  DeletePopconfirm: {
    doYouWantToDelete: 'Are you sure you want to delete?',
    yes: 'Yes',
    no: 'No',
  },
  Sorter: {
    selectSorter: 'Select sorter',
  },
  EditAction: {
    sureToEdit: 'Sure to edit?',
  },
  EditableTableCell: {
    pleaseInput: 'Please input {{field}}',
  },
  Dragger: {
    title: 'Click or drag file to this area to upload',
  },
  ExpandableNotes: {
    showLess: 'Show less',
    showMore: 'Show more',
  },
  GraphqlErrorMessages: {
    networkError:
      'Failed to fetch! Once you back online the request will be sent again!',
  },
  NotFoundPage: {
    subTitle: 'Sorry, the page you visited does not exist.',
    title: '404',
    backHome: 'Back home',
  },
  OfflineMutationsProvider: {
    unsavedDataExist: "You have unsaved data, please click 'OK' to save it",
    dataHasBeenSaved: 'All offline data has been saved!',
  },
  RestrictedLink: {
    noPermission: 'You don`t have permission',
  },
  CacheManager: {
    saveCache: 'Save cache',
    clearCache: 'Clear cache',
  },
  yearMonthSelect: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    selectMonth: 'Select month',
    selectYear: 'Select year',
  },
  TooltipWithOverflow: {
    copied: 'Copied to clipboard',
    failedToCopy: 'Failed to copy',
  },
  LocationFilterDropdown: {
    noLocationsFound: 'No locations found',
    loadMore: 'Load more...',
    searchLocations: 'Search locations...',
    assigned: 'Assigned',
    onlyAssigned: 'Only assigned locations',
    reset: 'Reset',
    ok: 'OK',
  },
  LocationsPickerDrawer: {
    cancel: 'Cancel',
    filter: 'Filter',
    locations: 'Locations',
    allLocations: 'All',
    more: 'more',
    selectLocations: 'Select Locations',
    searchLocations: 'Search locations...',
    selected: 'selected',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    done: 'Done',
    loadMore: 'Load more...',
    noLocationsFound: 'No locations found',
  },
  FilterChips: {
    more: 'more',
    activeFilters: 'Active filters:',
    resetAllFilters: 'Reset all filters',
    clearAllFilters: 'Clear all filters',
  },
  UnsavedChangesModal: {
    title: 'You have unsaved changes',
    message: 'If you leave now, your changes will be lost.',
    stayOnPage: 'Stay on page',
    saveAndLeave: 'Save & leave',
    discard: 'Discard changes',
  },
  AssignedLocationsSelect: {
    assignedLocations: 'Assigned locations',
    selectLocations: 'Select locations',
    selectRegionFirst: 'Please select a region first',
    selectedCount: 'Selected count',
    noLocationsFound: 'No locations found',
    noLocationsAvailable: 'No locations available',
    searchLocations: 'Search locations',
  },
  AssignedRegionsSelect: {
    assignedRegions: 'Assigned regions',
    selectRegions: 'Select regions',
  },
};
